let _sendAuthHeader = true;
let _env = process.env.REACT_APP_ENVIRONMENT;

//Example constans for firebase
let API_KEY = process.env.REACT_APP_API_KEY;
let AUTH_DOMAIN = process.env.REACT_APP_AUTH_DOMAIN;
let DATABASE_URL = process.env.REACT_APP_DATABASE_URL;
let STORAGE_BUCKET = process.env.REACT_APP_STORAGE_BUCKET;
let MESSAGING_SENDER_ID = process.env.REACT_APP_MESSAGING_SENDER_ID;
let PRODUCT_ID = process.env.PRODUCT_ID;
let EXCEL_TEMPLATE = process.env.REACT_APP_EXCEL_TEMPLATE;
let HAS_LOYALY_ACTIVE = process.env.REACT_APP_HAS_LOYALY_ACTIVE;
const USER_VERIFIED = process.env.REACT_APP_USER_VERIFIED; //Variable para saber si deben agregarse o no la posibilidad de verificar usuario y hacer ventas solo a usuarios verificados

//Example variable
const URL_PRODUCTS = "products";
const DUMMY = "dummy";

class Settings {
  static get env() {
    return _env;
  }

  static set env(value) {
    _env = value;
  }

  static get SERVICE_DOMAIN() {
    return process.env.REACT_APP_API_BASE;
  }
  static get SERVICE_DOMAIN_V2() {
    return process.env.REACT_APP_API_BASE_V2;
  }
  static get API_KEY() {
    return API_KEY;
  }
  static get AUTH_DOMAIN() {
    return AUTH_DOMAIN;
  }
  static get DATABASE_URL() {
    return DATABASE_URL;
  }
  static get STORAGE_BUCKET() {
    return STORAGE_BUCKET;
  }
  static get MESSAGING_SENDER_ID() {
    return MESSAGING_SENDER_ID;
  }

  static get PRODUCT_ID() {
    return PRODUCT_ID;
  }

  static get EXCEL_TEMPLATE() {
    return EXCEL_TEMPLATE;
  }

  static get sendAuthHeader() {
    return _sendAuthHeader;
  }

  static set sendAuthHeader(value) {
    _sendAuthHeader = value;
  }
  //Example getter
  static get productsEndpoint() {
    return URL_PRODUCTS;
  }

  //Variable para saber si deben agregarse o no la posibilidad de verificar usuario y hacer ventas solo a usuarios verificados
  static get IS_USER_VERIFIED() {
    return USER_VERIFIED == "on";
  }
  static get hasLoyaly() {
    return HAS_LOYALY_ACTIVE;
  }
}

module.exports = Settings;



// WEBPACK FOOTER //
// ./src/provider/base/Settings.js